var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.188 10.597a3.655 3.655 0 0 0 2.222-3.401 3.662 3.662 0 0 0-3.657-3.623A3.662 3.662 0 0 0 5.095 7.23a.684.684 0 1 0 1.367 0 2.293 2.293 0 0 1 2.29-2.29 2.293 2.293 0 0 1 .899 4.4c-.946.403-1.582 1.383-1.582 2.438a.684.684 0 1 0 1.367 0c0-.515.302-.989.752-1.181zm-1.435 2.89a.684.684 0 1 0 0 1.368.684.684 0 0 0 0-1.368zm8.751-4.24c0-2.337-.91-4.535-2.563-6.188A8.695 8.695 0 0 0 8.752.496c-2.337 0-4.535.91-6.188 2.563A8.695 8.695 0 0 0 0 9.248c0 2.338.91 4.535 2.564 6.188A8.695 8.695 0 0 0 8.752 18c1.6 0 3.167-.436 4.529-1.261a.684.684 0 1 0-.709-1.17 7.372 7.372 0 0 1-3.82 1.063c-4.072 0-7.384-3.312-7.384-7.384 0-4.072 3.312-7.385 7.384-7.385 4.072 0 7.385 3.313 7.385 7.385a7.354 7.354 0 0 1-1.252 4.098.684.684 0 0 0 1.136.76 8.718 8.718 0 0 0 1.483-4.858z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.f98b369b8a35229e3c41b708dde76c4e.svg";
export { ForwardRef as ReactComponent };